module.exports = __webpack_public_path__ + "static/img/HK-apple1.368a2b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HK-apple1.png
// module id = fCUA
// module chunks = 4